import { render, staticRenderFns } from "./c-btn.vue?vue&type=template&id=036de36a&scoped=true"
import script from "./c-btn.vue?vue&type=script&lang=ts"
export * from "./c-btn.vue?vue&type=script&lang=ts"
import style0 from "./c-btn.vue?vue&type=style&index=0&id=036de36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036de36a",
  null
  
)

export default component.exports